import { render, staticRenderFns } from "./LiveQuizManage.vue?vue&type=template&id=61fc699e&scoped=true"
import script from "./LiveQuizManage.vue?vue&type=script&lang=js"
export * from "./LiveQuizManage.vue?vue&type=script&lang=js"
import style0 from "./LiveQuizManage.vue?vue&type=style&index=0&id=61fc699e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc699e",
  null
  
)

export default component.exports